import page0001 from './0001.jpg';
import page0002 from './0002.jpg';
import page0003 from './0003.jpg';
import page0004 from './0004.jpg';
import page0005 from './0005.jpg';
import page0006 from './0006.jpg';
import page0007 from './0007.jpg';
import page0008 from './0008.jpg';
import page0009 from './0009.jpg';
import page0010 from './0010.jpg';
import page0011 from './0011.jpg';
import page0012 from './0012.jpg';
import page0013 from './0013.jpg';
import page0014 from './0014.jpg';
import page0015 from './0015.jpg';
import page0016 from './0016.jpg';
import page0017 from './0017.jpg';
import page0018 from './0018.jpg';
import page0019 from './0019.jpg';
import page0020 from './0020.jpg';
import page0021 from './0021.jpg';
import page0022 from './0022.jpg';
import page0023 from './0023.jpg';
import page0024 from './0024.jpg';
import page0025 from './0025.jpg';
import page0026 from './0026.jpg';
import page0027 from './0027.jpg';
import page0028 from './0028.jpg';
import page0029 from './0029.jpg';
import page0030 from './0030.jpg';
import page0031 from './0031.jpg';
import page0032 from './0032.jpg';
import page0033 from './0033.jpg';
import page0034 from './0034.jpg';
import page0035 from './0035.jpg';
import page0036 from './0036.jpg';
import page0037 from './0037.jpg';
import page0038 from './0038.jpg';
import page0039 from './0039.jpg';
import page0040 from './0040.jpg';
import page0041 from './0041.jpg';
import page0042 from './0042.jpg';
import page0043 from './0043.jpg';
import page0044 from './0044.jpg';
import page0045 from './0045.jpg';
import page0046 from './0046.jpg';
import page0047 from './0047.jpg';
import page0048 from './0048.jpg';
import page0049 from './0049.jpg';
import page0050 from './0050.jpg';
import page0051 from './0051.jpg';
import page0052 from './0052.jpg';
import page0053 from './0053.jpg';
import page0054 from './0054.jpg';
import page0055 from './0055.jpg';
import page0056 from './0056.jpg';
import page0057 from './0057.jpg';
import page0058 from './0058.jpg';
import page0059 from './0059.jpg';
import page0060 from './0060.jpg';
import page0061 from './0061.jpg';
import page0062 from './0062.jpg';
import page0063 from './0063.jpg';
import page0064 from './0064.jpg';
import page0065 from './0065.jpg';
import page0066 from './0066.jpg';
import page0067 from './0067.jpg';
import page0068 from './0068.jpg';
import page0069 from './0069.jpg';
import page0070 from './0070.jpg';
import page0071 from './0071.jpg';
import page0072 from './0072.jpg';
import page0073 from './0073.jpg';
import page0074 from './0074.jpg';
import page0075 from './0075.jpg';
import page0076 from './0076.jpg';
import page0077 from './0077.jpg';
import page0078 from './0078.jpg';
import page0079 from './0079.jpg';
import page0080 from './0080.jpg';
import page0081 from './0081.jpg';

export default [
  page0001,
  page0002,
  page0003,
  page0004,
  page0005,
  page0006,
  page0007,
  page0008,
  page0009,
  page0010,
  page0011,
  page0012,
  page0013,
  page0014,
  page0015,
  page0016,
  page0017,
  page0018,
  page0019,
  page0020,
  page0021,
  page0022,
  page0023,
  page0024,
  page0025,
  page0026,
  page0027,
  page0028,
  page0029,
  page0030,
  page0031,
  page0032,
  page0033,
  page0034,
  page0035,
  page0036,
  page0037,
  page0038,
  page0039,
  page0040,
  page0041,
  page0042,
  page0043,
  page0044,
  page0045,
  page0046,
  page0047,
  page0048,
  page0049,
  page0050,
  page0051,
  page0052,
  page0053,
  page0054,
  page0055,
  page0056,
  page0057,
  page0058,
  page0059,
  page0060,
  page0061,
  page0062,
  page0063,
  page0064,
  page0065,
  page0066,
  page0067,
  page0068,
  page0069,
  page0070,
  page0071,
  page0072,
  page0073,
  page0074,
  page0075,
  page0076,
  page0077,
  page0078,
  page0079,
  page0080,
  page0081,
];
